import { selectDescriptionLikeTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { selectCurriculumThemesValidation } from '@newStore/validation/validationRules/curriculumThemesConsistencyValidation';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';
import { curriculumSelectorComponent } from '@nodeTypeConfig/helpers/editComponents/curriculumSelector';
import { proThemesComponent } from '@nodeTypeConfig/helpers/editComponents/proDocumentStandardComponents';
import { titleAsDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const PRO_NEWSLETTER_CALENDAR: BuildingBlockNodeConfig = {
  nodeSelector: selectDescriptionLikeTitleNode,
  validationRules: [selectCurriculumThemesValidation],
  information: {
    single: 'Kalender',
    plural: 'Kalenders',
    ribonIcon: require('../../../../../img/buildingBlocks/CALENDAR.svg'),
  },
  createDefaults: {
    description: 'Kalender',
  },
  buildingBlocks: [{ type: NodeType.PRO_NEWSLETTER_EVENT }],
  edit: [titleAsDescriptionComponent, proThemesComponent, curriculumSelectorComponent],
  isCollapsible: true,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default PRO_NEWSLETTER_CALENDAR;
